{
    "InlineExitMessage": "Êtes-vous sûr de vouloir fermer cette fenêtre ? Toutes les configurations modifiées seront perdues à la fermeture.",
    "InlineExitConfirm": "Confirmer",
    "InlineExitCancel": "Annuler",
    "NotificationsModalTitle": "Notifications",
    "TabSettingsTitle": "Paramètres",
    "TabSettingsDoNotDisturb": "Activer",
    "TabSettingsCME": "CME",
    "TabSettingsTelServer": "Serveur de téléphonie",
    "TabSettingsPartition": "Partition \/ Site",
    "TabSettingsDevices": "Dispositifs",
    "TabSettingsChannels": "Canaux",
    "TabSettingsPhoneNumber": "Numéro de téléphone",
    "TabSettingsHeaderGeneral": "Général",
    "TabSettingsHeaderScopeFiltering": "Filtrage du champ d'application",
    "TabSettingsNotificationChannels": "Canaux de notification",
    "TabSetttingsPartitionValidation": "Vous ne pouvez sélectionner que 5 partitions au maximum.",
    "TabPreferencesTitle": "Préférences",
    "TabPreferencesHeadingUserNotifications": "Notifications aux utilisateurs",
    "IconAddTooltip": "Ajouter des notifications",
    "IconDisabledTooltip": "Les notifications sont désactivées",
    "IconEnabledTooltip": "Les notifications sont activées",
    "IconDisabled": "Handicapés",
    "NotificationsFooterHelp": "Aide",
    "NotificationsFooterCancel": "Annuler",
    "NotificationsFooterSubmit": "Économiser",
    "NotificationsFooterValiationWarning": "Veuillez corriger les erreurs avant de terminer",
    "NotificationPrefereencesThreshholdPlaceholder": "Placeholder",
    "NotificationPrefereencesThreshholdRequired": "Un seuil est nécessaire",
    "NotificationPrefereencesThreshholdInvalid": "Le seuil doit être un nombre",
    "NotificationFooterValidationError": "Erreurs de validation",
    "NAME": "NotificationsLanguageModal"
}